/**
 * Appointment Detail Page
 */
import { createFileRoute } from "@tanstack/react-router";
import { AppointmentDetail } from "@/components/scheduling/appointments/AppointmentDetail";

export const Route = createFileRoute(
  "/_authenticated/appointments/$appointmentId",
)({
  component: AppointmentDetailPage,
});

function AppointmentDetailPage() {
  const { appointmentId } = Route.useParams();
  return <AppointmentDetail appointmentId={appointmentId} />;
}
